import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { EmployeeRepository }   from 'Domain/Repositories';
import { message }              from 'antd';

export const deleteEmployeeEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.deleteEmployeeRequest.type),
    mergeMap(action => from(EmployeeRepository.remove(action.payload.id))
      .pipe(
        mergeMap(() => {
          message.success('Verwaltungsnutzer wurde erfolgreich gelöscht.');
          return from([
            Actions.deleteEmployeeSuccess({ id: action.payload.id }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.deleteEmployeeFailure(error),
          ]);
        })
      )
    ),
  );
};
